export default __webpack_public_path__ + "img/img_nura-6ebc558264c10dc7fa60e659c799d252.jpg";